import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link as ScrollLink } from 'react-scroll';
import classnames from 'classnames';
import env from '../../../config/env';
import messageValidator from '../../validations/messageValidator';
import { sendMessage } from '../../../actions/message';

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recaptcha: '',
      name: '',
      email: '',
      subject: '',
      message: '',
      errors: {},
      buttonText: 'Enviar',
      messageSent: false,
      messageSentClass: null,
    };
    this.onChangeCaptcha = this.onChangeCaptcha.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  onChangeCaptcha(value) {
    this.setState({
      recaptcha: value,
    });
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.isValid()) {
      this.setState({
        errors: {},
        buttonText: 'Por favor, aguarde',
        });

    this.props.sendMessage(this.state).then(() => {
      if (this.props.message === 'A sua mensagem foi enviada com sucesso!') {
        this.setState({
          name: '',
          email: '',
          subject: '',
          message: '',
          messageSent: this.props.message,
          messageSentClass: 'success-block',
          buttonText: 'Por favor, aguarde',
        });
      } else {
        this.setState({
          messageSent: 'Ocorreu um erro ao enviar a sua mensagem, por favor tente mais tarde.',
          messageSentClass: 'help-block',
          buttonText: 'Enviar',
        });
      }
    });
  }
}

isValid() {
  const { errors, isValid } = messageValidator(this.state);
  if (!isValid) {
    this.setState({ errors });
  }
  if (errors.email === 'O email é inválido') {
    this.setState({
      email: '',
    });
  }
  return isValid;
}

render() {
  const { props } = this;
  const { errors, name, email, subject, message, messageSent, messageSentClass, buttonText } = this.state;
  const bgImage = `url(${env.url}${props.collection.image.path})`;

  return (
    <section id={props.sectionId} className={`bottom spotlight ${props.sectionStyle}`} style={{ backgroundPosition: 'center center', backgroundImage: bgImage }}>
      <span className="image fit main"><img src={`${env.url}${props.collection.image.path}`} alt="" /></span>
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="w40">
              <header>
                <h2>{props.collection.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: props.collection.content }}></div>
              </header>
            </div>
            <div className="w60 multi-column">
              <div className="contact-form">
                <div>
                  <input autoComplete="off" onChange={this.onChange} value={name} name="name" placeholder={errors.name ? errors.name : "Nome"} className={classnames('input-form', { 'error': errors.name })} />
                </div>
                <div>
                  <input autoComplete="off" onChange={this.onChange} value={email} name="email" placeholder={errors.email ? errors.email : "Email"} className={classnames('input-form', { 'error': errors.email })} />
                </div>
                <div>
                  <input autoComplete="off" onChange={this.onChange} value={subject} name="subject" placeholder={errors.subject ? errors.subject : "Assunto"} className={classnames('input-form', { 'error': errors.subject })} />
                </div>
                <div>
                  <textarea onChange={this.onChange} value={message} name="message" rows="5" placeholder={errors.message ? errors.message : "Deixe a sua mensagem..."} className={classnames('input-form', { 'error': errors.message })} />
                </div>
                <div>
                  <ReCAPTCHA
                    ref="recaptcha"
                    sitekey="6LcmW1cUAAAAAHV1Zgz2Ydwa5l9vJ95Hxy4ZBIWz"
                    onChange={this.onChangeCaptcha}
                  />
                  {errors.recaptcha &&
                    <span className="help-block">{errors.recaptcha}</span>
                  }
                </div>
                <div>
                  <button type="submit" onClick={this.onSubmit}>{buttonText}</button>
                </div>
                {messageSent &&
                  <div>
                    <span className={messageSentClass}>{messageSent}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
}
};


function mapStateToProps(state) {
  return { message: state.message.message };
}

export default connect(mapStateToProps, { sendMessage })(ContactUs);

ContactUs.propTypes = {
  sectionId: PropTypes.string,
  sectionStyle: PropTypes.string,
  href: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/wrapper/section/ContactUs.js